<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :showHeader="showHeader"
  >
    <div class="mb-8">
      <v-btn
        :data-cy="`${entityName}__yesButton--${attributeName}`"
        :disabled="disabled"
        :outlined="value === valueYes"
        :text="value !== valueYes"
        @click="value = valueYes"
        color="primary"
        >Yes</v-btn
      >
      <v-btn
        :data-cy="`${entityName}__noButton--${attributeName}`"
        :disabled="disabled"
        :outlined="value === valueNo"
        :text="value !== valueNo"
        @click="value = valueNo"
        color="primary"
        >No</v-btn
      >
      <v-btn
        :disabled="disabled"
        @click="value = null"
        icon
        v-if="!(value === null || value === undefined)"
      >
        <v-icon>fas fa-times-circle</v-icon>
      </v-btn>
    </div>
  </component-wrapper>
</template>

<script>
import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  mixins: [userInputMixin],
  props: {
    valueNo: {
      validator: v => v !== null && v !== undefined,
      required: true,
    },
    valueYes: {
      validator: v => v !== null && v !== undefined,
      required: true,
    },
  },
};
</script>

<style scoped>
.btn-override::before {
  opacity: 0 !important;
}
</style>
